import styled, { css } from 'styled-components';
import { colors, media } from 'tsx/theme';

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .step {
    position: absolute;
    color: white;
    font-weight: 600;
  }
  .text {
    position: absolute;
    color: ${colors.text};
    opacity: 0.85;
    width: 150px;
    text-align: center;
    top: 50px;
  }

  ${media.lg(css`
    .text {
      font-size: 14px;
      width: 120px;
    }
  `)};
  ${media.md(css`
    .text {
      top: 40px;
      width: 100px;
      font-size: 12px;
    }
  `)};
  ${media.sm(css`
    .text {
      display: none;
    }
  `)};
`;

interface StepProps {
  step: number;
  isActive: boolean;
  text: string;
}

export const Step: React.FC<StepProps> = ({ step, isActive, text }) => {
  return (
    <Div>
      <svg width="56" height="36" viewBox="0 0 56 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 18C0 8.05888 8.05887 0 18 0H56V19C56 28.3888 48.3888 36 39 36H18C8.05888 36 0 27.9411 0 18Z"
          fill={isActive ? `url(#paint0_linear_2029_1244-${step})` : '#9C84AD'}
        />
        {isActive && (
          <defs>
            <linearGradient
              id={`paint0_linear_2029_1244-${step}`}
              x1="8.70623e-09"
              y1="23.1925"
              x2="56.0015"
              y2="23.1761"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#632573" />
              <stop offset="1" stopColor="#2A042D" />
            </linearGradient>
          </defs>
        )}
      </svg>
      <p className="step">{step}</p>
      <p className="text">{text}</p>
    </Div>
  );
};

<svg width="56" height="36" viewBox="0 0 56 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    opacity="0.98"
    d="M0 18C0 8.05888 8.05887 0 18 0H56V19C56 28.3888 48.3888 36 39 36H18C8.05888 36 0 27.9411 0 18Z"
    fill="#9C84AD"
  />
</svg>;
